// extracted by mini-css-extract-plugin
export var arrows = "_1s-6";
export var decrementer = "_1s-a";
export var disabled = "_1s-4";
export var error = "_1s-1";
export var hiddenText = "_1s-b";
export var incrementer = "_1s-9";
export var input = "_1s-8";
export var inputWrapper = "_1s-0";
export var leadingIcon = "_1s-c";
export var readonly = "_1s-3";
export var regular = "_1s-7";
export var small = "_1s-5";
export var warning = "_1s-2";